export default "__VITE_ASSET__BaHqRFu1__"